const listCountries = [
  { value: "br", name: "brasil" },
  { value: "us", name: "estadosUnidos" },
  { value: "es", name: "espanha" },
  { value: "fr", name: "franca" },
  { value: "ca", name: "canada" },
  { value: "mx", name: "mexico" },
  { value: "de", name: "alemanha" },
  { value: "it", name: "italia" },
  { value: "cn", name: "china" },
  { value: "jp", name: "japao" },
  { value: "co", name: "colombia" },
  { value: "ua", name: "ucrania" },
  { value: "ru", name: "russia" },
  { value: "in", name: "india" },
  { value: "id", name: "indonesia" },
  { value: "pk", name: "paquistao" },
  { value: "ng", name: "nigeria" },
  { value: "bd", name: "bangladesh" },
  { value: "et", name: "etiopia" },
  { value: "ph", name: "filipinas" },
  { value: "eg", name: "egito" },
  { value: "vn", name: "vietna" },
  { value: "cd", name: "repuplicaDemocraticaDoCongo" },
  { value: "tr", name: "turquia" },
  { value: "ir", name: "ira" },
  { value: "th", name: "tailandia" },
  { value: "gb", name: "reinoUnido" },
  { value: "tz", name: "tanzania" },
  { value: "za", name: "africaDoSul" },
  { value: "mm", name: "mianmar" },
  { value: "kr", name: "coreiaDoSul" },
  { value: "ke", name: "quenia" },
  { value: "ug", name: "uganda" },
  { value: "sd", name: "sudao" },
  { value: "ar", name: "angertina" },
  { value: "dz", name: "angelia" },
  { value: "iq", name: "iraque" },
  { value: "pl", name: "polonia" },
  { value: "uz", name: "uzbequistao" },
  { value: "sa", name: "arabiaSaudita" },
];

const listLanguage = [
  { value: "br", name: "br", language: "Português" },
  { value: "en", name: "en", language: "Estados Unidos" },
  { value: "es", name: "es", language: "Espanhol" },
  { value: "fr", name: "fr", language: "Francês" },
  { value: "de", name: "de", language: "Alemão" },
  { value: "it", name: "it", language: "Italiano" },
  { value: "jp", name: "jp", language: "Japonês" },
  { value: "cn", name: "cn", language: "Chinês" },
  { value: "kr", name: "kr", language: "Coreano" },
  { value: "ru", name: "ru", language: "Russo" },
  { value: "pl", name: "pl", language: "Polonês" },
  { value: "ua", name: "ua", language: "Ucraniano" },
  { value: "sd", name: "sd", language: "Árabe" },
  { value: "in", name: "in", language: "Hindi" },
  { value: "id", name: "id", language: "Indonésio" },
  { value: "pk", name: "pk", language: "Urdu" },
  { value: "bd", name: "bd", language: "Bengali" },
  { value: "et", name: "et", language: "Amárico" },
  { value: "ph", name: "ph", language: "Filipino (Tagalo)" },
  { value: "vn", name: "vn", language: "Vietnamita" },
  { value: "tr", name: "tr", language: "Turco" },
  { value: "ir", name: "ir", language: "Persa" },
  { value: "th", name: "th", language: "Tailandês" },
  { value: "za", name: "za", language: "Africâner" },
  { value: "mm", name: "mm", language: "Birmanês" },
  { value: "ug", name: "ug", language: "Suaíli" },
  { value: "uz", name: "uz", language: "Uzbeque" },
];
const listProficiency = [
  { value: "basic", name: "basic" },
  { value: "conversational", name: "conversational" },
  { value: "fluent", name: "fluent" },
  { value: "native", name: "native" },
];
export { listCountries, listLanguage, listProficiency };
